
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsf509245dc75a02c6ea1bfa3ddc5b9903en from './en.yaml'
            i18n.addResourceBundle('en', 'f509245dc75a02c6ea1bfa3ddc5b9903', flattenObject(nsf509245dc75a02c6ea1bfa3ddc5b9903en), true, true);
        
        export default 'f509245dc75a02c6ea1bfa3ddc5b9903';
    